<template>
  <div class="company_mobile">
    <p class="company_common_title">
      <span>{{companyName}}</span>
    </p>

    <div class="deal">
      <title-temp title="Deal overview"></title-temp>
      <!-- <div class="deal_info title_info">
        <p v-for="(item, index) of Config.dealData[0]" :key="index" class="info_item">
          <span class="info_title">{{item.label}}:</span>
          <span class="columnText1" :title="dealData[item.field]">{{dealData[item.field]}}</span>
        </p>
      </div>-->
      <table-list :column="Config.dealData[1]" :tableData="dealData.target" :showNumber="false"></table-list>
      <table-list :column="Config.dealData[2]" :tableData="dealData.acquiror" :showNumber="false"></table-list>
      <table-list :column="Config.dealData[3]" :tableData="dealData.vendor" :showNumber="false"></table-list>
      <!-- <div class="deal_info regulatory_info">
        <p v-for="(item, index) of Config.dealData[4]" :key="index" class="info_item">
          <span class="info_title">{{item.label}}:</span>
          <span>{{dealData[item.field]}}</span>
        </p>
      </div>-->
    </div>

    <!-- deal dates -->
    <div class="deal_status">
      <title-temp title="Deal structure & dates"></title-temp>
      <!-- <table-form :columnData="Config.dealDates" :tableData="datesData"></table-form> -->
      <single-column :columnData="Config.dealDates" :data="datesData"></single-column>
    </div>

    <!-- deal values -->
    <div class="deal_values">
      <title-temp title="Deal values"></title-temp>
      <!-- <table-form :columnData="Config.dealValues" :tableData="valuesData"></table-form> -->
      <single-column :columnData="Config.dealValues" :data="valuesData"></single-column>
    </div>
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import TableForm from "common/components/tableForm";
import TableList from "common/components/table";
import SingleColumn from "./SingleColumn";

import Config from "conf/Transcation";

import { getZephyrOverview, getZephyrStructure } from "common/js/http/v2Api";

export default {
  props: ["conditions"],

  components: {
    TitleTemp,
    TableList,
    TableForm,
    SingleColumn
  },

  data() {
    return {
      Config,
      companyName: "",
      dealData: {},
      datesData: {},
      valuesData: {}
    };
  },

  created() {
    this.getOverview();
    this.getStructure();
  },

  methods: {
    async getOverview() {
      const { result } = await getZephyrOverview(this.conditions);
      result.target = this.converJsonStringData(result.target);
      result.vendor = this.converJsonStringData(result.vendor);
      result.acquiror = this.converJsonStringData(result.acquiror);

      this.companyName = result.deal_headline;
      // 共用一个接口
      this.dealData = result;
      this.valuesData = result;
    },

    async getStructure() {
      const { result } = await getZephyrStructure(this.id);
      this.datesData = result;
    },

    converJsonStringData(data) {
      try {
        if (data.includes("{") && data.includes("}")) {
          return JSON.parse(data);
        } else {
          let resultData = [];
          resultData = data.split(",").map(item => {
            let dataReturn = {};
            item.split(";").forEach(objItem => {
              const obj = objItem.split(":");
              dataReturn[obj[0]] = obj[1];
            });
            return dataReturn;
          });
          return resultData;
        }
      } catch (error) {
        return [];
      }
    }
  }
};
</script>

<style scoped>
.company_common_title {
  padding-top: 10px;
}

.company_mobile {
  overflow: auto;
  height: 100%;
  padding-bottom: 150px;
}
</style>